<template>
    <div class="reset-password">
        <hub-form v-slot:formcontent ref="hubForm" :onSubmit="savePassword">

            <div class="logo">
                <img src="/logo.png" />
                <h2>X-CUBE</h2>
            </div>

            <h5>RESET PASSWORD</h5>

            <input placeholder="password" type="password" v-model="model.password" maxLength="32" minLength="5"
                required />
            <input placeholder="confirm password" type="password" v-model="model.confirmPassword" maxLength="32"
                minLength="5" required />
            <button @submit.prevent>Reset password</button>
        </hub-form>
    </div>
</template>

<script setup>
import { ref } from "vue";
import { Message } from "element-ui";
import * as Sentry from "@sentry/vue";
import { useRoute, useRouter } from "vue-router/composables";
import { request } from "../../api/rest";
import HubForm from "../shared/Form.vue";

const router = useRouter();
const route = useRoute();
const hubForm = ref(null);

const token = route.params.token;
const model = ref({
    code: token,
    password: "",
    confirmPassword: "",
});

const savePassword = async () => {
    if (model.value.password !== model.value.confirmPassword) {
        hubForm.value.error("Passwords do not match");
        return;
    }

    try {
        const result = await request(
            "/auth/reset-password",
            { method: "POST" },
            {
                code: token,
                password: model.value.password,
                passwordConfirmation: model.value.password,
            },
        );

        hubForm.value.res = result.status;

        if (result.status >= 200 && result.status < 299) {
            hubForm.value.success("Your password has been updated.");
            const res = await result.json();
            const jwt = res.jwt;
            Message.success({ message: "Password has been changed" });
            router.push({ name: "booking", params: { jwt } });
        } else {
            Message.error({ message: "Could not change password, please contact support."});
        }
    } catch (error) {
        console.error("Reset password error:", error);
        Message.error({ message: "An error occurred while resetting your password."});
        Sentry.captureException(error);
    }
};
</script>

<style scoped>
.reset-password {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
}

img {
    height: 64px;
}


form:not(.el-form) {
  button {
    margin-top: 24px;
    cursor: pointer;
  }
}
</style>
